import React, { useMemo } from "react";
import "./streaming.css";

const SHIMMER_MS = 1500;
const t0 = Date.now() - performance.now(); // monotonic-ish epoch

/**
 * Calculates the animation delay needed to sync with a global shimmer cycle.
 * Returns a negative delay (in seconds) to "catch up" to the current phase.
 */
function phaseDelaySeconds(): number {
  const now = performance.now() + t0;
  return -((now % SHIMMER_MS) / 1000);
}

interface ShimmerTextProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Text component with synchronized shimmer animation.
 * All ShimmerText instances share the same animation phase regardless of mount time.
 */
export function ShimmerText({ children, className = "", style }: ShimmerTextProps) {
  // Calculate delay once on mount - recalculating on re-render would restart the animation
  const delay = useMemo(() => phaseDelaySeconds(), []);

  return (
    <span
      className={`streaming-shimmer ${className}`.trim()}
      style={{ animationDelay: `${delay}s`, ...style }}
    >
      {children}
    </span>
  );
}
